// extracted by mini-css-extract-plugin
export default {"root":"_1HkcWrhD8uEMm3JhUIlIci","outlineBtn":"_18dBKM0un0MgdTwGAP83hj","connect":"_3qGa6oqn88ubghDYTwTjU"};